<template>
	<div class="tempD">
		<div class="pageTit"><span @click="goHome">1522只智能设计之家首页</span> > <span>{{user.nickname?user.nickname:user.name}}的作品</span></div>
		<div class="uInfoD">
			<div class="uphoto">
				<img :src="user?user.headimg?imgAPI + user.headimg:require('../../../../public/icon/001.jpg'):require('../../../../public/icon/001.jpg')" @click="" />
			</div>
			<div class="uInfoTest">
				<div class="uInfoTest_one">
					<div class="unickname">
						<span>{{user.nickname?user.nickname:user.name}}</span><span style=""></span>
						<span style="margin-left: 50px;font-size: 0.8rem;">联系方式：</span>
						<span>{{user.phone?user.phone:''}}</span>
					</div>
					<!--<div class="editBtn btn_addWorks" @click="open_userEdit">编辑</div>-->
				</div>
				<div class="uInfoTest_two">
					<div class="selfIntroduction">
						<p v-if="user.introduce_myself==''">您什么都还没介绍</p>
						<p v-else="">{{user.introduce_myself?user.introduce_myself:user.introduce}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="my_worksD">
			<div class="designCase_arr">
				<div class="anliList" style="display: flex;flex-direction: row;flex-wrap: wrap;">
					<div class="anliList_item" v-for="ai,index in anliArr" @click="seePhoto(ai)" style="width: 20%;border: 5px solid #f2f2f2;box-sizing: border-box;">
						<div class="anliList_itemImg">
							<img :src="imgAPI+ai.imgUrlArr[0]" style="width: 100%;" />
							<div class="userInfo">
								<div class="usname">{{ai.title}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<el-dialog title="" :show-close="false" :visible.sync="seePhotoDlog" class="myDlog myDlog_opa" :fullscreen="true">
			<worksInfoDlog :pageParams="pageParams" v-on:parentMethod="communication" v-if="seePhotoDlog"></worksInfoDlog>
		</el-dialog>
	</div>
</template>

<script>
	import baseConst from '../../../assets/js/baseConst.js' //注意路
	const worksInfoDlog = () =>
		import("@/components/home/works/works_info.vue"); //作品详情
	export default {
		components: {
			worksInfoDlog
		},
		data() {
			return {
				user:{},
				imgAPI:'',
				anliArr:[],
				seePhotoDlog:false
			}
		},
		created: function() {
			let _this = this;
			_this.imgAPI = baseConst.IMG_API;
			_this.user = JSON.parse(_this.$route.query.pagePrams);
			_this.getDesignLise();
		},
		mounted: function() {
			let _this = this;

		},
		methods: {
			/**  * -----s设置高度    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			setTempDH() {
				let offsetHeight = document.documentElement.clientHeight;
				console.log(document.getElementsByClassName("tempD")[0])
				document.getElementsByClassName("tempD")[0].style.minHeight = offsetHeight + 'px';
			},
			/*获取设计案例
			 创建于2019-11-25  作者：郑凯*/
			getDesignLise() {
				let _this = this;
				let params = {
					limit: 20000,
					pageNumber: 1,
					design_org_id: _this.user.design_org_id
				};
				_this.getApi('/api/getDesignOrgWorks', params)
					.then((res) => {
						if(res.status == '00') {
							_this.pageNumber = res.data.pageNumber;
							_this.anliArr = res.data.data;
							for(let i = 0; i < _this.anliArr.length; i++) {
								let imgUrlArr = [];
								imgUrlArr = _this.anliArr[i].works.split('|');
								_this.anliArr[i].imgUrlArr = imgUrlArr;
							}
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			
			/**  * -----查看图片
			 * @version 1.0  * @author 您的大名 2019年11月21日  * */
			seePhoto(obj) {
				let _this = this;
				_this.pageParams = JSON.parse(JSON.stringify(obj));
				_this.seePhotoDlog = true;
				setTimeout(function() {
					document.getElementsByClassName("el-dialog__body")[0].scrollTop = 0;
				}, 100)
			},

			/**  * -----处理图集图片数量    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			handlePhotoNum(imgText) {
				let arr = imgText.split('|');
				return arr.length;
			},

			/**  * -----查看详情    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			open_seeInfo(ob) {
				let _this = this;
				_this.editWorksPageParams = JSON.parse(JSON.stringify(ob))
				_this.works_info_dlog = true;
			},
			/**  * -----编辑资料    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			open_userEdit(ob) {
				let _this = this;
				_this.userEdit_dlog = true;
			},
			/**  * -----去往首页     * @version 1.0  * @author 您的大名 2019年12月3日  * */
			goHome() {
				let _this = this;
				_this.$router.push('homePage');
			},

			/**  * -----这个组件的子组件通信处理    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			communication(type) {
				let _this = this;
				switch(type) {
					case 'works_add':
						_this.works_add_dlog = false;
						_this.getWorksList();
						break;
					case 'works_edit':
						_this.works_edit_dlog = false;
						_this.getWorksList();
						break;
					case 'works_info':
						_this.seePhotoDlog = false;
						break;
					case 'user_edit':
						let userObj = JSON.parse(localStorage.getItem('ind_user'));
						_this.userObj = userObj;
						_this.userEdit_dlog = false;
						break;
					default:
				}
			},
		},
		watch: {
			'checkIdArr': {
				handler: function(val, oldVal) {
					//console.log(val)
				},
				deep: true
			}
		},
	}
</script>

<style scoped>
	.tempD{ min-height: 100vh; }
	.tempD{ width: 100%; padding: 0 4rem; box-sizing: border-box; margin: auto; background-image: url(../../../../public/img/001.jpg); background-size: cover; background-repeat: no-repeat;}
	.pageTit{ height: 5rem; line-height: 5rem; border-bottom: 1px solid #ccc;}
	.pageTit span:nth-child(1){ font-weight: bold; cursor: pointer;}
	.pageTit span:nth-child(2){ color: #7D7D7D;}
	.uInfoD{ display: flex; flex-direction: row; padding: 1rem;}
	.uphoto{ position: relative; width: 8rem; height: 8rem; border-radius: 50%; overflow: hidden;}
	.changeHeadImg{ position: absolute; width: 100%; height: 100%; background-color: rgb(0, 0, 0, 0.5); top: 0; left: 0; text-align: center; display: inline-flex; align-items: center; justify-content: center; color: #fff; cursor: pointer;}
	.uphoto img{ width: 100%; cursor: pointer;}
	.uInfoTest{ flex: 1; padding: 0 0.5rem;}
	.uInfoTest_one{ height: 50%; width: 100%; border-bottom: 1px solid #ccc; display: inline-flex; align-items: center; position: relative;}
	.unickname{ font-size: 1.6rem;}
	.unickname span:nth-child(2){ font-size: 12px; color: #7D7D7D; margin-left: 10px;}
	.editBtn{ position: absolute; right: 0;}
	.uInfoTest_two{ overflow: hidden; /*height: 50%;*/margin-bottom: 20px;}
	.selfIntroduction{ font-size: 13px; padding: 5px;}
	.my_worksD{ background-color: rgba(255, 255, 255, 0.4); padding: 1rem 0; box-sizing: border-box; border-radius: 5px; padding: 10px;}
	.one_tit{ height: 3rem; line-height: 3rem; padding: 0 0.5rem; font-weight: bold;}
	.btn_addWorks{ border: none; margin-left: 15px; background-color: #6C6C6C; color: #fff; padding: 5px 10px; cursor: pointer; border-radius: 3px;}
	.my_works_table{ width: 90%; margin: auto; border: none; border-collapse: collapse;
		/*加上这个将tr和td的border属性分开*/
		}
	.my_works_table tr{
		/*line-height: 3rem;*/
		padding: 20px 0;}
	.my_works_table tr th{ border: none; padding: 20px 0;}
	.my_works_table tr td{ border: none; text-align: center; padding: 20px 0;}
	.tbody_tr{ border-bottom: 1px solid #ccc;
		/*line-height: 5rem!important;*/
		}
	.tbody_tr:hover{ transform: scale(1.001); box-shadow: 0 0 5px #7D7D7D; -webkit-box-shadow: 0 0 5px #7D7D7D; -moz-box-shadow: 0 0 5px #7D7D7D; -ms-box-shadow: 0 0 5px #7D7D7D; -o-transform: scale(1.001); -moz-transform: scale(1.001); -ms-transform: scale(1.001); -o-transform: scale(1.001);}
	.table_operation{ text-align: right!important;}
	.table_operation button{ border: none; margin-left: 0.5rem; cursor: pointer;}
	.table_operation .btn_del {}
	
	.tablePage{ width: 90%; text-align: right; height: 50px; display: inline-flex; align-items: center; justify-content: flex-end; box-sizing: border-box; margin-left: 5%!important;}
	.checkWorks_box{ width: 30px; height: 30px; cursor: pointer;}
	.oU_select{ margin-left: 15px;}
	.masonry{ -moz-column-count: 5;
		/* Firefox */
		-webkit-column-count: 5;
		/* Safari 和 Chrome */
		column-count: 5; -moz-column-gap: 0.5em; -webkit-column-gap: 0.5em; column-gap: 0.5em; width: 100%; margin: 0.1em auto; padding-bottom: 1rem;}
	.item{ margin-bottom: 1em; -moz-page-break-inside: avoid; -webkit-column-break-inside: avoid; break-inside: avoid;
		/*background: #f60;*/
		background-color: rgb(220, 220, 220); cursor: pointer;}
	.masonry .item:hover{ box-shadow: 0px 0px 5px #ccc; transform: scale(1.03);}
	.item_content img{ width: 100%; display: block;}
	@media screen and (max-width: 800px){ .masonry{ column-count: 5;}
		}
	@media screen and (max-width: 500px){ .masonry{ column-count: 5;}
		}
	.designTeam_arr .designTeam_arr_item{ width: 20%;}
	.userPotot{ width: 150px; height: 150px; background-color: red; border-radius: 50%; margin: auto; overflow: hidden;}
	.userPotot img{ width: 100%;}
	.userName{ text-align: center; padding: 20px 0; padding-bottom: 30px; font-weight: bold;}
	.userInfo{ width: 100%; display: flex; flex-direction: row; padding: 10px;}
	.usphoto{ width: 40px; height: 40px; border-radius: 50%; background-color: #fff; overflow: hidden;}
	.usname{ display: flex; align-items: center; padding-left: 5px; padding-right: 15px; box-sizing: border-box;}
	.imgD{ width: 70%; min-height: 100px; margin: auto; display: flex; flex-direction: row;}
	.imgD .imgD_left{ width: 70%; box-shadow: 0 0 8px #ccc; padding: 15px; background-color: #fff;}
	.imgD .imgD_left img{ width: 100%;}
	.imgD .imgD_right{ flex: 1; margin-left: 20px;}
	.photoTime{ background-color: #fff; box-shadow: 0 0 8px #ccc; padding: 5px;}
	.uutime{ padding: 5px 0; color: #ccc; margin-top: 8px;}
	.myDlog .el-dialog__wrapper{ background-color: rgba(255, 255, 255, 0.8);}
	.seemoreDe{ height: 5rem; text-align: center; font-size: 20px; line-height: 5rem; margin-top: 20px;}

	.anliList_item { cursor: pointer; }
	.anliList_item:hover{  transform: scale(1.03);box-shadow: 0px 0px 5px #ccc; }
</style>
<style type="text/css">
	.myDlog_1 .el-dialog{ display: flex; flex-direction: column; margin: 0 !important; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); max-height: calc(100% - 30px); max-width: calc(100% - 30px);}
	.myDlog_1 .el-dialog .el-dialog__header{ padding: 0;}
	.myDlog_1 .el-dialog .el-dialog__body{ flex: 1; overflow: auto; padding: 10px; border-radius: 10px;}
	.infoDlog.myDlog_1 .el-dialog{ min-height: 100%; min-width: 100%;}
	.oU_select .el-input--suffix .el-input__inner{ background-color: #6c6c6c; height: 30px; color: #fff;}
	.oU_select .el-input--suffix .el-input__inner::placeholder{ color: #fff;}

</style>